import { render } from "./ProductosVue.vue?vue&type=template&id=52b1ac29&scoped=true"
import script from "./ProductosVue.vue?vue&type=script&lang=js"
export * from "./ProductosVue.vue?vue&type=script&lang=js"

import "./ProductosVue.vue?vue&type=style&index=0&id=52b1ac29&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b1ac29"]])

export default __exports__